import React, { useState } from 'react';
import { graphql } from 'gatsby';
import { Button, Headline, Lead, SEO, SitewideFooter, SitewideHeader } from '../../components';
import FormsCenteredHero from '../../components/landing/CenteredHero/FormsCenteredHero';
import {
  AlternatingFeatureBlock,
  CustomerLogoCloud,
  FAQs,
  SimpleCenteredHeading,
  SplitGridLogoCloud,
  TestimonialsCloud,
  TextBasedFeatureBlock,
} from '../../components/landing';
import FormsCustomerLogoCloud from '../../components/landing/FormsCustomerLogoCloud';
import GatheringInfoStep from '../../../static/images/landing/GatheringInfoStep.png';
import {
  FingerPrintIcon,
  MapIcon,
  BeakerIcon,
  ShieldCheckIcon,
  PresentationChartLineIcon,
  PencilAltIcon,
  ChartBarIcon,
  BadgeCheckIcon,
  CheckCircleIcon,
  ShareIcon,
  FolderIcon,
  BellIcon,
  DocumentIcon,
  GiftIcon,
} from '@heroicons/react/outline';
import {
  FaClipboardCheck,
  FaSync,
  FaFileAlt,
  FaMagic,
  FaFileInvoice,
  FaAlignJustify,
  FaRocket,
  FaUpload,
  FaBriefcase,
  FaToggleOn,
  FaTasks,
  FaCalendarAlt,
  FaListAlt,
  FaShareAlt,
  FaFolderOpen,
} from 'react-icons/fa';
import { AiOutlineForm, AiOutlineFileSync } from 'react-icons/ai';
import HipaaLogo from '../../../content/assets/logos/hipaa/hipaa.inline.svg';
import FerpaLogo from '../../../content/assets/logos/ed/ferpa-logo.png';

import LanguageProficiency from '../../../content/assets/home/forms/LanguageProficiency.png';
import ShareFormInSpanish from '../../../content/assets/home/forms/ShareFormInSpanish.png';
import FormsUseCases from '../../components/landing/UseCases/FormsUseCases';
import EvaluboxFormsRequestAccessForm from '../../components/CallToAction/EvaluboxFormsRequestAccessForm';
import EmailCaptureForm from '../../components/CallToAction/EmailCaptureForm';
import { SubmissionSuccessModal } from '../../components/FormSubmissionModal';
import { InlineWidget } from 'react-calendly';
import { SCM_TOOLS } from '../../components/forms/ScmToolRadioGroup';
import { PurchaseTeamsTier, SectionHeader } from '../../components/pricing';
import FormsTestimonials from '../../components/landing/Testimonials/FormsTestimonialsCloud';
import PurchaseExaminerProTier from '../../components/pricing/PurchaseExaminerProTier';
import PurchaseExaminerPremiumTier from '../../components/pricing/PurchaseExaminerPremiumTier';
import BillingFrequencySwitcher from '../../components/pricing/BillingFrequencySwitcher';
import FormPricingStarter from '../../components/pricing/FormPricingStarter';
import Logo from '../../components/Logo';
import FormPricingTeam from '../../components/pricing/FormPricingTeam';
import NarrativeCenteredHero from '../../components/landing/CenteredHero/NarrativeCenteredHero';
import AlternatingFeatureBlockProducts from '../../components/landing/FeatureBlocks/AlternatingFeatureBlockProducts';

const SEO_TITLE = 'Complete Intakes Faster';
const isBrowser = () => typeof window !== 'undefined';
const FREE_TRIAL_DAYS = 30;

const SubmissionSuccessPositiveBody = () => (
  <>
    <p>Thank you for requesting Evalubox Forms. We&apos;ll be in touch via the email provided.</p>
    {/* <h3>Schedule a call today to get access sooner.</h3> */}
    {/* <InlineWidget
      styles={{
        height: '700px',
      }}
      url="https://calendly.com/evalubox/getting-started/?hide_event_type_details=1&hide_gdpr_banner=1"
    />  */}
  </>
);

const SubmissionSuccessNegativeBody = () => (
  <>
    <p>
      Something went wrong and we were unable to capture your request. Please contact us here:
      admin@evalubox.com to process your request.{' '}
    </p>
  </>
);

export const Registration = () => {
  const params = new URLSearchParams(isBrowser() && location.search);
  const emailFromUrl = decodeURIComponent(params.get('email') || '');
  // params.delete("email");
  var url = isBrowser() && window.location.href;
  if (isBrowser() && url) {
    var urlSplit = url.split('?');
    var stateObj = { Title: document.title, Url: urlSplit[0] };
    history.pushState(stateObj, stateObj.Title, stateObj.Url);
  }

  //   <ul className="list-disc list-inside mb-4 pl-8 text-base space-y-2">
  //   <li><strong>Customizable Questions:</strong> Choose exactly what you need to ask, ensuring every form is tailored to your specific needs.</li>
  //   <li><strong>Multilingual Magic:</strong> Send forms in up to 16 different languages effortlessly. We'll handle the translations for you, so language barriers are a thing of the past.</li>
  //   <li><strong>Automatic Notifications:</strong> Receive real-time updates as soon as forms are completed, and get all responses translated back to English automatically.</li>
  //   <li><strong>Single-Use Links:</strong> All forms are single-use links that expire once completed, ensuring data safety and security. They are HIPAA and FERPA compliant.</li>
  //   <li><strong>Personalized Data:</strong> Each form is unique to each client, making it easy to manage and track personalized data for all your clients.</li>
  //   <li><strong>Progress Tracking:</strong> You can track the progress of each form sent, making it easy to manage and follow up as needed.</li>
  // </ul>

  const VALUE_PROPS = {
    features: [
      {
        title: '1. Record or Upload Your Audio Files with Ease',
        description: `Quickly capture or upload language sample recordings directly into Evalubox from any device.  
        <br /> <br />
        Our platform supports various audio formats, ensuring you can seamlessly upload your existing recordings. You can also record directly into the tool. 
        `,
        illustration: {
          // webp: DragDropIllustration,
          // png: ShareForm,
          alt: 'Video showing how to upload and record language sample inside of Evalubox using the narrative assessment tool',
          src: 'https://cdn.app.evalubox.com/marketing-site/narrative-assessment/Step+1+-+Record+or+Upload+Your+Language+Samples+with+Ease.mp4',
          cover:
            'https://cdn.app.evalubox.com/marketing-site/narrative-assessment/Step+1+Record+or+Upload+Your+Language+Samples+with+Ease+thumbnail.png',
        },
        illustrationIsVideo: true,
        bullets: [],
      },
      {
        title: '2. Automatic Transcription Done in Seconds',
        description: `Say goodbye to tedious manual transcriptions. Evalubox automatically transcribes your language samples and makes editing easy. This saves you valuable time and reduces the potential for errors.
        <br /> <br />
        You can focus on what matters most - analyzing the results. `,
        illustration: {
          // webp: DragDropIllustration,
          // png: AssessmentImpressions,
          alt: 'Video showing how Evalubox automatically transcribes language samples for narrative language assessments',
          src: 'https://cdn.app.evalubox.com/marketing-site/narrative-assessment/Step+2+-+Automatic+Transcription+Done+in+Minutes.mp4',
          cover:
            'https://cdn.app.evalubox.com/marketing-site/narrative-assessment/Step+2+Automatic+Transcription+Done+in+Minutes+Thumbnail.png',
        },
        illustrationIsVideo: true,
        bullets: [],
      },
      {
        title: `3. Detailed Analysis for Confident Decision Making`,
        description: `Evalubox walks you through an in-depth analysis of grammar, narrative structure, and other key linguistic features. 
        <br /> <br />
        Get a complete, easy-to-read report that supports your professional judgment with confidence. 
        `,
        illustration: {
          // webp: DragDropIllustration,
          // png: BgReportPic,
          alt: 'Video showing how to go from analyzing language samples inside of Evalubox to generating a final report for narrative language assessments',
          src: 'https://cdn.app.evalubox.com/marketing-site/narrative-assessment/Step+3+-+Detailed+Analysis+for+Confident+Decision+Making.mp4',
          cover:
            'https://cdn.app.evalubox.com/marketing-site/narrative-assessment/Step+3+-+Detailed+Analysis+for+Confident+Decision+Making+Thumbnail.png',
        },
        illustrationIsVideo: true,
        bullets: [],
      },
    ],
  };

  const PRODUCT = {
    features: [
      {
        title: 'Know the status of every form.',
        // description:
        //   'Organize not only the information in your current report, but for every report you write in the future.',
        illustration: {
          // webp: DragDropIllustration,
          png: GatheringInfoStep,
          alt: 'An overview of an evaluation in progress from Evalubox',
        },
        bullets: [
          // {
          //   name: 'Reduced Error Rate',
          //   description:
          //     'Minimizes the risk of manual errors that could occur when transcribing handwritten or manually filled-out forms.',
          //   icon: FaClipboardCheck,
          // },
          {
            name: 'Real-Time Progress Tracking',
            description:
              "Monitor the completion status of forms in real time, enabling you to stay updated on the evaluation's progress and make timely interventions as needed.",
            icon: AiOutlineForm,
          },
          // {
          //   name: 'Professional Image',
          //   description:
          //     'Using a modern and tech-savvy approach to evaluations enhances your professional image as a provider and as an educational institution.',
          //   icon: AiOutlineFileSync,
          // },
        ],
      },
      {
        title: 'Language Exposure - automatically calculated for you.',
        // description:
        //   'Organize not only the information in your current report, but for every report you write in the future.',
        illustration: {
          // webp: DragDropIllustration,
          png: LanguageProficiency,
          alt: 'Language proficiency from Evalubox',
        },
        bullets: [
          // {
          //   name: 'Testing Impressions',
          //   description:
          //     'Easily capture your testing impressions while they are fresh in your mind and have it automatically populated into your report.',
          //   icon: FaClipboardCheck,
          // },
          {
            name: 'Language profiency',
            description:
              'Quickly determine whether assessment and intervention should be conducted in one or more languages.',
            icon: AiOutlineForm,
          },
          // {
          //   name: 'Smart templates',
          //   description:
          //     'Use your existing template or select one of our pre-designed templates to automatically populate your report with your intake and testing data with one click.',
          //   icon: AiOutlineFileSync,
          // },
        ],
      },
      {
        title: 'Share in multiple languages.',
        // description:
        //   'Organize not only the information in your current report, but for every report you write in the future.',
        illustration: {
          // webp: DragDropIllustration,
          png: ShareFormInSpanish,
          alt: 'Language proficiency from Evalubox',
        },
        bullets: [
          // {
          //   name: 'Testing Impressions',
          //   description:
          //     'Easily capture your testing impressions while they are fresh in your mind and have it automatically populated into your report.',
          //   icon: FaClipboardCheck,
          // },
          {
            name: 'Reduced Communication Barriers',
            description:
              'Remove language barriers between you and parents from diverse linguistic backgrounds to improved communication and understanding.',
            icon: AiOutlineForm,
          },
          // {
          //   name: 'Smart templates',
          //   description:
          //     'Use your existing template or select one of our pre-designed templates to automatically populate your report with your intake and testing data with one click.',
          //   icon: AiOutlineFileSync,
          // },
        ],
      },
    ],
  };
  const SOLUTIONS_2 = {
    features: [
      {
        title: 'Parent Referall forms in their language of choice',
        description:
          'Securely share intake forms and Evalubox will gather the information you need.',
        // prompt: 'Closed beta',
        bullets: [
          {
            name: 'Share intake forms',
            description:
              'Send links to parents, teachers, and nurses and have their responses automatically added to your reports.',
            icon: ShareIcon,
          },
          {
            name: 'Track missing documents',
            description:
              'Send personalized follow-up messages in multiple languages and gather the information you need in a timely manner. ',
            icon: BellIcon,
          },
        ],
      },
      {
        title: 'Teacher referrals',
        description:
          'Securely share intake forms and Evalubox will gather the information you need.',
        // prompt: 'Closed beta',
        bullets: [
          {
            name: 'Share intake forms',
            description:
              'Send links to parents, teachers, and nurses and have their responses automatically added to your reports.',
            icon: ShareIcon,
          },
          {
            name: 'Track missing documents',
            description:
              'Send personalized follow-up messages in multiple languages and gather the information you need in a timely manner. ',
            icon: BellIcon,
          },
        ],
      },
      {
        title: 'Health forms',
        description:
          'Securely share intake forms and Evalubox will gather the information you need.',
        // prompt: 'Closed beta',
        bullets: [
          {
            name: 'Share intake forms',
            description:
              'Send links to parents, teachers, and nurses and have their responses automatically added to your reports.',
            icon: ShareIcon,
          },
          {
            name: 'Track missing documents',
            description:
              'Send personalized follow-up messages in multiple languages and gather the information you need in a timely manner. ',
            icon: BellIcon,
          },
        ],
      },
    ],
  };

  const PRIVACY_COMPLIANCE_SUPPORTED = {
    title: 'Keep important records safe',
    subTitle: `Evalubox is HIPAA compliant and FERPA compliant. HIPAA regulations (The HIPAA Privacy Rule) requires that Covered Entities sign an agreement with their Business Associates. Evalubox will sign a Business Associate Agreement (BAA) for all customers.`,
    link: {
      text: 'Learn more about how we keep your data safe and give you peace of mind.',
      to: '/security/',
    },

    logos: [
      {
        src: <HipaaLogo />,
        key: 'hipaa',
      },
      {
        src: <img src={FerpaLogo} alt="Ferpa compliance logo" className="" />,
        key: 'ferpa',
      },
    ],
  };
  // window.history.replaceState(null, null, '?email='+emailFromUrl);
  // const cycleFromUrl = decodeURIComponent(params.get('cycle') || 'annual');
  // window.location.href =  window.location.href.split("?")[0]
  const [modalOpen, setModalOpen] = useState(false);
  const [scmTool, setScmTool] = useState(SCM_TOOLS[0].value);

  const handleCloseModal = () => {
    setModalOpen(false);
  };
  const [currentlySetFrequency, setFrequency] = useState('Annual');

  return (
    <section className="w-full">
      {/* <div className="flex justify-start lg:w-0 lg:flex-1 top-0 left-0  px-6 py-4 ">
        <Logo />
      </div>
      */}

      <SubmissionSuccessModal
        scmTool={scmTool}
        handleCloseModal={handleCloseModal}
        modalOpen={modalOpen}
        // siteMetadata={data.site.siteMetadata}
        positiveTitle="We'll be in touch!"
        positiveBody={<SubmissionSuccessPositiveBody />}
        negativeTitle="Oops! We're not ready for you yet."
        negativeBody={<SubmissionSuccessNegativeBody />}
        followOn="CONFIRM_DEMO"
      />

      <NarrativeCenteredHero />
      <TrustedBySection />

      <ProblemSection />

      <SolutionIntroSection />
      <div className="py-10 bg-gray-50 relative overflow-hidden" id="product">
        <AlternatingFeatureBlockProducts content={VALUE_PROPS} />
      </div>
      <NarrativeCTA />
      <FAQSection />

      {/* <ResourcesSection /> */}
      {/* <TestimonialsSection /> */}
      {/* <NarrativeCTA /> */}
      <ComparisonSection />
      <UseCasesSection />
      {/* <div className="bg-white">
        <div className="max-w-7xl mx-auto py-24 px-4 sm:px-6 lg:px-8">
          <div className="sm:flex sm:flex-col sm:align-center">
            <div className="sm:text-center">
              <Headline el="h2">Pricing for Narrative Assessment</Headline>
              <div className="mt-5">
                <Lead>
                  Trusted by Speech Language Pathologists in Every Setting Who Need a Safe, Rapid
                  Way to Conduct Narrative Assessments, Transcribe Language Samples, Analyze
                  Results, and Create Comprehensive Reports
                </Lead>
              </div>
            </div>
          </div>
          <div className="mt-12 space-y-4 sm:mt-16 grid grid-cols-1 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-6 lg:max-w-4xl lg:mx-auto">
            <FormPricingStarter currentlySetFrequency={currentlySetFrequency} />
            <FormPricingTeam currentlySetFrequency={currentlySetFrequency} />
          </div>
        </div>
      </div> */}
      <UniqueCapabilitiesSection />

      <SplitGridLogoCloud content={PRIVACY_COMPLIANCE_SUPPORTED} />
      <div className="pt-14 bg-blue-50 pb-10" id="solutions">
        <NarrativeCTA />
      </div>
      <SitewideFooter />
    </section>
  );
};

const NarrativeCTA = () => {
  return (
    <>
      <SimpleCenteredHeading
        headline="Start Transcribing Language Samples For Free"
        lead="Simply create an account to experience how Evalubox's Language Sampling Tool will transform your testing. Are you a clinic or school lead? Contact us to get a quote for your entire organization. "
      />
      <div className=" mx-auto text-center max-w-2xl mb-10">
        {/* <RequestAccessForm from={"home-page"} showTC={true} /> */}
        <div className="inline-flex">
          <Button
            link={true}
            to="https://app.evalubox.com/register?intent=narrative&utm_medium=display&utm_source=narrative&utm_campaign=narrative_to_evalubox_register&utm_content=cta-try-for-free"
            color="primary"
            text="Get Started For Free"
            size="large"
          />
        </div>

        <div className="ml-3 inline-flex">
          <Button
            link={true}
            to="/request-demo/?utm_medium=display&utm_source=narrative&utm_campaign=narrative_to_demo&utm_content=cta-request-demo"
            color="inset"
            text="Request a Quote"
            size="large"
          />
        </div>
      </div>
    </>
  );
};

const NarrativeAssessment = ({ data, location }) => {
  return (
    <>
      <SitewideHeader
        borderBottom={false}
        ctaTo="https://app.evalubox.com/register?intent=narrative&utm_medium=display&utm_source=narrative&utm_campaign=narrative_header_to_evalubox_register&utm_content=cta-hero-try-it-for-free"
        ctaText="Try it For Free"
      />
      <Registration />
    </>
  );
};

export default NarrativeAssessment;

export const Head = () => (
  <>
    <SEO
      title={`Language Sample`}
      description="The first ever language sample collection tool that automatically transcribes, assists with language sample analysis, and generates a report!"
    />
  </>
);

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`;

const FAQSection = () => {
  return (
    <>
      <div className=" px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto bg-gray-50">
        <div className="max-w-2xl mx-auto text-center mb-10 lg:mb-14">
          <h2 className="text-2xl font-bold md:text-3xl md:leading-tight text-gray-800 ">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="grid sm:grid-cols-2 gap-6 md:gap-12">
            <div>
              <h3 className="text-lg font-semibold text-gray-800 ">How does it work?</h3>
              <p className="mt-2 text-gray-600 ">
                The Language Sampling Tool follows the exact same language sampling process that has
                been pioneered and used at Bilinguistics since 2002. The difference? This tool takes
                care of the repetitive, time consuming, administrative hassles leaving you to do
                more professional analysis. You record into the tool or upload an audio file. It’s
                transcribed for you. You edit it and are guided through a process to check for
                narrative (e.g., characters, setting) and grammatical (e.g., verbs, pronouns)
                components. If you are satisfied with the child’s performance, a report is created
                for you. If you want more information, have the child tell a second story after
                hearing an example, analyze it, and hit print to produce a report comparing the two.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-800 ">How much does it cost? </h3>
              <p className="mt-2 text-gray-600 ">
                The only way to understand the speed and accuracy of the Language Sampling Tool is
                to experience it. That’s why we’ve created a way for you to try it out for free.
                After that, professionals pay per use or subscribe to access this and the whole
                suite of tools inside Evalubox.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-800 ">
                What if the child speaks a different language?
              </h3>
              <p className="mt-2 text-gray-600 ">
                If a child speaks a home language other than English and their initial language
                sample isn’t typical, we have to bring into question the influence of the home
                language. Here’s how it works. Have the child tell a story in their home language.
                Review the transcript with a native speaker (e.g., parent, translator/interpreter)
                using the analytical walkthrough. It sounds like this: “We are checking to see if
                the child identified the character/setting/used nouns… do you see that?” You can
                then compare the samples. Many times we see stronger language samples in a student's
                native language.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-800 ">
                What if the child is unintelligible or has a speech disorder?
              </h3>
              <p className="mt-2 text-gray-600 ">
                After a sample is transcribed, you have a chance to edit it. It’s a side-by-side
                screen where you play the audio and change the transcription. We put X for
                unintelligible words so that we have an accurate word count and utterance length. We
                also include sound errors (e.g., gog for dog) because we use this for our speech
                sample as well. Why reinvent the wheel or do it twice?
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-800 ">
                I am new to language sampling. Is this for me?
              </h3>
              <p className="mt-2 text-gray-600 ">
                Absolutely. Embedded in how the tool works is training on the process you should
                use. Here’s what it looks like: A child tells a story from a wordless picture book
                with no example. This is called a Story Tell. You upload it and use it to answer
                questions about grammatical and narrative components. If the story looks good,
                you’re done! Hit print.
                <br /> <br />
                Let’s say the story does not look that great. Now you have to rule out whether the
                child has no experience telling stories or did not know what you were asking her to
                do. You tell her a story and then ask her to do a Story Retell of the same story.
                Upload and analyze. If the second story is more robust, chances are she lacked
                experience. If the second story looks the same, this is a good indication of a
                disorder and should be taken into consideration with your other testing.
                <br /> <br />
                If the child is bilingual, the process is much the same. If the first Story Tell is
                not what you would expect for the child’s age, a second story would be collected in
                their home language. You then work with a native speaker to analyze the story
                components and compare.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const TrustedBySection = () => {
  return (
    <>
      <div className="max-w-4xl px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
        <div className="mx-auto text-center mb-6">
          <h2 className="text-gray-600  text-2xl">
            Trusted by Speech Language Pathologists Across the Nation.
          </h2>
        </div>
      </div>
    </>
  );
};
const ResourcesSection = () => {
  return (
    <>
      {/*Icon Blocks */}
      <div className="max-w-xl px-4 sm:px-6 lg:px-8 mx-auto">
        <div className="max-w-2xl mx-auto text-center mb-4 lg:mb-4">
          <h2 className="text-center text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            Resources
          </h2>
        </div>
        <div className="grid sm:grid-cols-1 lg:grid-cols-1 items-center gap-2">
          {/*Icon Block */}
          <a
            className="group flex flex-col justify-center hover:bg-gray-50 rounded-xl p-4 md:p-7 "
            href="#"
          >
            <div className="flex justify-center items-center size-12 bg-primary rounded-xl">
              <svg
                className="flex-shrink-0 size-6 text-white"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect width="10" height="14" x="3" y="8" rx="2" />
                <path d="M5 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-2.4" />
                <path d="M8 18h.01" />
              </svg>
            </div>
            <div className="mt-5">
              <h3 className="group-hover:text-gray-600 text-lg font-semibold text-gray-800 ">
                Narrative Assessment Resources
              </h3>
              <p className="mt-1 text-gray-600 ">
                Download our narrative assessment guide in PDF format to help you better understand
                the process and make the most of your Evalubox experience.
              </p>
              <span className="mt-2 inline-flex items-center gap-x-1.5 text-sm text-blue-600 decoration-2 group-hover:underline font-medium">
                Download them here
                <svg
                  className="flex-shrink-0 size-4"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="m9 18 6-6-6-6" />
                </svg>
              </span>
            </div>
          </a>
          {/*End Icon Block */}
        </div>
      </div>
      {/*End Icon Blocks */}
    </>
  );
};
const TestimonialsSection = () => {
  return (
    <>
      {/* Testimonials */}
      <div className="max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6">
          {/* Card */}
          <div className="flex flex-col bg-white border border-gray-200 shadow-sm rounded-xl ">
            <div className="flex-auto p-4 md:p-6">
              {/* <svg className="w-20 h-auto sm:w-24 text-gray-700 dark:text-neutral-300" width="140" height="47" viewBox="0 0 140 47" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.3991 8.15082C20.3991 9.61789 19.1416 10.8754 17.6745 10.8754C16.2075 10.8754 14.95 9.61789 14.95 8.15082C14.95 6.68375 16.2075 5.42627 17.6745 5.42627C19.1416 5.42627 20.3991 6.68375 20.3991 8.15082ZM17.6745 13.1109C16.0678 13.1109 14.8103 14.3684 14.8103 15.9752C14.8103 17.582 16.0678 18.8394 17.6745 18.8394C19.2813 18.8394 20.5388 17.582 20.5388 15.9752C20.5388 14.2985 19.2813 13.1109 17.6745 13.1109ZM17.6745 20.7257C16.0678 20.7257 14.7404 22.053 14.7404 23.6598C14.7404 25.2666 16.0678 26.5939 17.6745 26.5939C19.2813 26.5939 20.6087 25.2666 20.6087 23.6598C20.6785 22.053 19.2813 20.7257 17.6745 20.7257ZM17.6745 28.4802C16.0678 28.4802 14.8103 29.7376 14.8103 31.3444C14.8103 32.9512 16.0678 34.2087 17.6745 34.2087C19.2813 34.2087 20.5388 32.9512 20.5388 31.3444C20.5388 29.8075 19.2813 28.4802 17.6745 28.4802ZM17.6745 36.3744C16.2075 36.3744 14.95 37.6319 14.95 39.0989C14.95 40.566 16.2075 41.8235 17.6745 41.8235C19.1416 41.8235 20.3991 40.566 20.3991 39.0989C20.3991 37.6319 19.2115 36.3744 17.6745 36.3744ZM25.2195 12.7616C23.4729 12.7616 22.0059 14.2287 22.0059 15.9752C22.0059 17.7217 23.4729 19.1887 25.2195 19.1887C26.966 19.1887 28.433 17.7217 28.433 15.9752C28.433 14.2287 26.966 12.7616 25.2195 12.7616ZM25.2195 20.3764C23.4031 20.3764 21.8662 21.8434 21.8662 23.7297C21.8662 25.546 23.3332 27.083 25.2195 27.083C27.0358 27.083 28.5728 25.6159 28.5728 23.7297C28.5728 21.8434 27.0358 20.3764 25.2195 20.3764ZM25.2195 28.1309C23.4729 28.1309 22.0059 29.5979 22.0059 31.3444C22.0059 33.0909 23.4729 34.558 25.2195 34.558C26.966 34.558 28.433 33.0909 28.433 31.3444C28.433 29.5979 26.966 28.1309 25.2195 28.1309ZM32.9739 19.9572C31.0179 19.9572 29.2714 21.564 29.2714 23.6598C29.2714 25.6159 30.8781 27.3624 32.9739 27.3624C35.0698 27.3624 36.6765 25.7556 36.6765 23.6598C36.5368 21.564 34.93 19.9572 32.9739 19.9572ZM10.0598 13.4602C8.73243 13.4602 7.61466 14.578 7.61466 15.9053C7.61466 17.2327 8.73243 18.3504 10.0598 18.3504C11.3871 18.3504 12.5049 17.2327 12.5049 15.9053C12.5049 14.578 11.457 13.4602 10.0598 13.4602ZM10.0598 21.075C8.59271 21.075 7.47494 22.1927 7.47494 23.6598C7.47494 25.1269 8.59271 26.2446 10.0598 26.2446C11.5268 26.2446 12.6446 25.1269 12.6446 23.6598C12.6446 22.1927 11.5268 21.075 10.0598 21.075ZM10.0598 28.8295C8.73243 28.8295 7.61466 29.9472 7.61466 31.2746C7.61466 32.6019 8.73243 33.7197 10.0598 33.7197C11.3871 33.7197 12.5049 32.6019 12.5049 31.2746C12.5049 29.9472 11.457 28.8295 10.0598 28.8295ZM2.445 21.4941C1.18752 21.4941 0.209473 22.4722 0.209473 23.7297C0.209473 24.9871 1.18752 25.9652 2.445 25.9652C3.70249 25.9652 4.68053 24.9871 4.68053 23.7297C4.68053 22.4722 3.70249 21.4941 2.445 21.4941Z" fill="currentColor"></path>
          <path d="M64.4812 18.9092C64.2018 18.9092 63.9922 19.1886 63.9922 19.3982V38.7495C63.9922 39.0289 64.2716 39.2385 64.4812 39.2385H66.7866C67.066 39.2385 67.2756 38.9591 67.2756 38.7495V19.3982C67.2756 19.1188 66.9962 18.9092 66.7866 18.9092H64.4812Z" fill="currentColor"></path>
          <path d="M65.7389 10.7358C64.4815 10.7358 63.5034 11.7139 63.5034 12.9714C63.5034 14.2289 64.4815 15.2069 65.7389 15.2069C66.9964 15.2069 67.9745 14.2289 67.9745 12.9714C67.9745 11.7139 66.9266 10.7358 65.7389 10.7358Z" fill="currentColor"></path>
          <path d="M114.082 18.9092C113.803 18.9092 113.593 19.1886 113.593 19.3982V38.7495C113.593 39.0289 113.873 39.2385 114.082 39.2385H116.388C116.667 39.2385 116.877 38.9591 116.877 38.7495V19.3982C116.877 19.1188 116.597 18.9092 116.388 18.9092H114.082Z" fill="currentColor"></path>
          <path d="M115.2 10.7358C113.942 10.7358 112.964 11.7139 112.964 12.9714C112.964 14.2289 113.942 15.2069 115.2 15.2069C116.457 15.2069 117.435 14.2289 117.435 12.9714C117.435 11.7139 116.457 10.7358 115.2 10.7358Z" fill="currentColor"></path>
          <path d="M138.603 37.3525C138.743 37.2127 138.743 37.073 138.743 37.0031C138.743 36.8634 138.743 36.8634 138.743 36.8634C138.743 36.8634 138.743 36.7237 138.603 36.7237C138.603 36.7237 138.463 36.584 138.324 36.584C138.184 36.584 138.184 36.584 138.044 36.584H137.416V38.3305H137.695V37.7018H138.044L138.533 38.3305H138.813L138.184 37.562C138.463 37.6319 138.603 37.4922 138.603 37.3525ZM137.765 37.4922V36.8634H138.254C138.394 36.8634 138.533 36.8634 138.603 37.0031C138.743 37.0031 138.743 37.1429 138.743 37.2826C138.743 37.4223 138.743 37.562 138.603 37.562C138.463 37.562 138.324 37.7018 138.254 37.7018H137.765V37.4922Z" fill="currentColor"></path>
          <path d="M138.114 35.8853C137.276 35.8853 136.507 36.6537 136.507 37.492C136.507 38.3304 137.276 39.0988 138.114 39.0988C138.952 39.0988 139.721 38.3304 139.721 37.492C139.721 36.5839 139.022 35.8853 138.114 35.8853ZM138.114 38.9591C137.276 38.9591 136.647 38.3304 136.647 37.492C136.647 36.6537 137.276 36.025 138.114 36.025C138.952 36.025 139.581 36.6537 139.581 37.492C139.581 38.3304 138.883 38.9591 138.114 38.9591Z" fill="currentColor"></path>
          <path d="M83.6928 22.0531C83.9722 22.0531 84.1818 21.7737 84.1818 21.5641V19.2587C84.1818 18.9793 83.9024 18.7697 83.6928 18.7697H78.7327V11.3645C78.7327 11.0851 78.4533 10.8755 78.2437 10.8755H75.9383C75.6588 10.8755 75.4493 11.1549 75.4493 11.3645V18.7697H73.0042C72.7247 18.7697 72.5151 19.0491 72.5151 19.2587V21.5641C72.5151 21.8436 72.7946 22.0531 73.0042 22.0531H75.4493V33.2308C75.4493 36.6539 77.7547 38.8895 81.108 38.8895H83.5531C83.8325 38.8895 84.0421 38.61 84.0421 38.4004V36.0951C84.0421 35.8156 83.7626 35.606 83.5531 35.606H81.4573C79.8505 35.606 78.7327 34.4883 78.7327 32.7418V21.9833L83.6928 22.0531Z" fill="currentColor"></path>
          <path d="M132.735 22.0531C133.014 22.0531 133.224 21.7737 133.224 21.5641V19.2587C133.224 18.9793 132.944 18.7697 132.735 18.7697H127.775V11.3645C127.775 11.0851 127.495 10.8755 127.286 10.8755H124.98C124.701 10.8755 124.491 11.1549 124.491 11.3645V18.7697H122.046C121.767 18.7697 121.557 19.0491 121.557 19.2587V21.5641C121.557 21.8436 121.837 22.0531 122.046 22.0531H124.491V33.2308C124.491 36.6539 126.797 38.8895 130.15 38.8895H132.595C132.874 38.8895 133.084 38.61 133.084 38.4004V36.0951C133.084 35.8156 132.805 35.606 132.595 35.606H130.36C128.753 35.606 127.635 34.4883 127.635 32.7418V21.9833L132.735 22.0531Z" fill="currentColor"></path>
          <path d="M49.8106 22.053V38.5401C49.8106 38.8195 50.09 39.0291 50.2996 39.0291H52.605C52.8844 39.0291 53.094 38.7497 53.094 38.5401V22.053H58.5431C58.8226 22.053 59.0321 21.7736 59.0321 21.564V19.2586C59.0321 18.9792 58.7527 18.7696 58.5431 18.7696H53.094V14.4383C53.094 12.6918 54.3515 11.5041 55.8186 11.5041H58.5431C58.8226 11.5041 59.0321 11.2247 59.0321 11.0151V8.70973C59.0321 8.43028 58.7527 8.2207 58.5431 8.2207H55.9583C52.5351 8.2207 49.8106 11.085 49.8106 14.3684V18.7696H47.3655C47.086 18.7696 46.8765 19.049 46.8765 19.2586V21.564C46.8765 21.8435 47.1559 22.053 47.3655 22.053H49.8106Z" fill="currentColor"></path>
          <path d="M106.258 21.2148C104.442 19.2587 101.857 18.1409 99.1321 18.1409C96.5473 18.1409 93.9625 19.2587 92.3557 20.8655V8.57008C92.3557 8.29064 92.0763 8.08105 91.8667 8.08105H89.5613C89.2818 8.08105 89.0723 8.3605 89.0723 8.57008V28.8994C89.0723 36.4443 94.1022 39.7278 99.0623 39.7278C103.952 39.7278 109.052 36.3745 109.052 28.8994C109.052 25.8954 108.074 23.1709 106.258 21.2148ZM99.0623 36.584C94.1022 36.584 92.2858 32.6719 92.2858 28.9693C92.2858 24.4284 95.0104 21.4244 99.0623 21.4244C103.114 21.4244 105.839 24.4982 105.839 28.9693C105.769 32.6719 104.022 36.584 99.0623 36.584Z" fill="currentColor"></path>
        </svg> */}

              <p className="mt-3 sm:mt-6 text-base text-gray-800 md:text-xl ">
                <em>
                  " Evalubox has transformed how we conduct our assessments. It's faster, more
                  reliable, and has significantly reduced the time spent on clerical tasks. "
                </em>
              </p>
            </div>

            <div className="p-4 rounded-b-xl md:px-6">
              <h3 className="text-sm font-semibold text-gray-800 sm:text-base ">Emily R</h3>
              <p className="text-sm text-gray-500 ">SLP | Boston Public Schools</p>
            </div>
          </div>
          {/* End Card */}

          {/* Card */}
          <div className="flex flex-col bg-white border border-gray-200 shadow-sm rounded-xl ">
            <div className="flex-auto p-4 md:p-6">
              {/* <svg className="w-20 h-auto sm:w-24 text-gray-700 dark:text-neutral-300" width="200" height="67" viewBox="0 0 200 67" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M192.914 45.0629C197.106 45.0629 200 42.1687 200 38.1767C200 36.1807 199.401 34.2845 198.403 32.9871C197.305 31.5899 195.709 30.7915 193.812 30.7915C191.317 30.7915 188.922 32.6877 186.627 36.6797L186.427 36.9791L186.327 36.6797C185.729 34.9831 185.23 33.5859 184.93 32.7875C184.731 32.1887 184.631 31.9891 184.631 31.8893C184.531 31.4901 184.132 31.1907 183.633 31.1907C183.333 31.1907 183.034 31.2905 182.735 31.4901C182.435 31.6897 182.236 31.8893 182.236 32.1887C179.94 39.3743 178.044 42.8673 176.447 42.8673C176.248 42.8673 176.048 42.7675 175.948 42.6677C175.549 42.1687 175.649 41.0709 175.749 39.5739C175.848 38.4761 175.948 37.1787 175.948 35.8813C175.848 33.2865 174.451 31.6897 172.156 31.6897C169.261 31.6897 167.365 34.7835 166.467 36.5799L166.168 37.0789L166.068 36.4801C165.868 34.1847 165.07 31.4901 162.675 31.4901C159.88 31.4901 157.685 34.7835 156.387 37.5779L156.088 38.2765V37.4781C156.287 33.7855 156.387 31.5899 156.487 30.9911C156.587 30.3923 156.487 29.9931 156.287 29.6937C156.088 29.4941 155.788 29.3943 155.19 29.3943C154.291 29.4941 153.792 29.9931 153.094 31.7895C151.996 34.7835 149.102 41.8693 146.707 41.8693C146.208 41.8693 145.908 41.6697 145.609 41.3703C144.611 40.2725 145.01 37.2785 145.609 33.0869V32.7875C145.908 30.7915 145.409 30.3923 144.311 30.1927C144.212 30.1927 144.112 30.1927 144.012 30.1927C143.114 30.1927 142.715 30.9911 141.916 33.2865C140.519 37.3783 138.623 41.5699 136.527 41.5699C136.427 41.5699 136.327 41.5699 136.327 41.5699C135.23 41.3703 135.23 39.6737 135.23 37.5779C135.23 36.3803 135.23 35.0829 135.13 33.9851C134.83 31.8893 133.533 30.5919 131.836 30.4921C128.443 30.4921 126.248 34.7835 125.15 37.3783L124.95 37.9771L124.85 37.3783C124.651 35.6817 124.551 34.0849 124.451 32.3883V32.2885C130.739 24.4043 133.533 18.6158 133.633 13.7256C133.633 10.6318 132.236 8.7356 129.741 8.7356C127.944 8.7356 123.752 10.2326 122.255 24.0051C121.956 26.5999 121.856 29.1947 121.856 31.7895C118.962 35.9811 112.774 43.1667 106.786 43.1667C101.297 43.1667 97.006 38.7755 97.006 30.9911C97.006 20.6118 104.391 14.2246 109.88 14.2246C111.078 14.2246 112.076 14.524 112.874 15.2226C113.673 15.9212 114.072 16.8194 114.072 17.8174C114.072 19.2146 113.573 20.013 113.174 20.7116C113.074 20.9112 112.974 21.1108 112.874 21.3104C112.774 21.51 112.675 21.8094 112.774 22.009C112.874 22.3084 113.273 22.4083 113.772 22.4083C115.07 22.4083 117.066 20.512 117.066 17.6178C117.066 14.6238 114.571 11.53 109.98 11.53C103.094 11.53 93.9122 19.015 93.9122 31.2905C93.9122 39.8733 99.3014 45.8613 106.687 45.8613C111.876 45.8613 117.066 42.1687 121.557 35.8813L121.856 35.4821V35.9811C121.956 38.2765 122.156 40.0729 122.255 41.3703C122.355 42.1687 122.355 42.8673 122.355 43.1667C122.355 43.8653 122.455 44.4641 122.754 44.7635C123.054 45.0629 123.453 45.2625 124.052 45.2625C125.05 45.2625 125.25 44.5639 125.649 42.8673L125.749 42.3683C126.248 40.2725 128.144 33.4861 130.938 33.4861C131.437 33.4861 131.737 33.5859 132.036 33.8853C132.635 34.5839 132.535 35.8813 132.535 37.4781C132.535 38.4761 132.435 39.4741 132.535 40.4721C132.834 43.0669 133.932 44.3643 136.028 44.4641C138.124 44.4641 140.419 42.1687 141.617 40.0729L141.816 39.6737L141.916 40.1727C142.116 41.2705 143.114 45.0629 146.108 45.0629C148.902 45.0629 151.198 42.1687 153.792 36.1807L154.092 35.3823V36.2805C153.992 38.5759 153.892 41.2705 153.892 43.4661C153.892 45.1627 154.092 45.7615 154.79 45.7615H154.99C155.689 45.7615 156.188 45.3623 156.487 44.4641C158.483 37.6777 160.08 34.4841 161.776 34.4841C163.373 34.4841 163.573 37.4781 163.673 42.7675V43.1667C163.673 44.9631 163.772 45.8613 164.97 45.8613C165.868 45.8613 166.068 45.1627 166.467 43.4661C166.567 43.1667 166.667 42.7675 166.766 42.3683C168.363 36.8793 169.661 34.6837 171.257 34.6837C172.655 34.6837 172.755 36.0809 172.755 36.5799C172.854 37.5779 172.754 38.6757 172.555 39.6737C172.455 40.6717 172.355 41.5699 172.355 42.5679C172.455 44.6637 173.653 45.8613 175.649 45.9611C178.343 45.9611 180.639 42.8673 182.735 36.7795L182.834 36.3803L183.034 36.7795C183.433 37.7775 183.932 39.0749 184.331 40.5719V40.6717V40.7715C182.335 45.2625 180.838 50.2526 180.838 52.9472C180.838 56.4402 182.435 58.7356 184.93 58.8354C186.327 58.8354 189.421 58.3364 189.521 53.2466C189.521 51.1508 189.022 48.2566 188.024 44.5639L187.924 44.1647L188.323 44.3643C190.02 44.5639 191.517 45.0629 192.914 45.0629ZM124.651 27.8973C124.751 26.5999 124.85 25.4023 124.95 24.2047C125.948 16.7196 127.944 11.4302 129.94 11.4302C130.838 11.4302 131.337 12.1288 131.337 13.526C131.337 16.9192 129.142 21.8094 124.95 27.9971L124.651 28.4961V27.8973ZM186.826 54.9432C186.527 55.3424 186.128 55.542 185.529 55.542C184.93 55.542 184.431 55.3424 184.132 54.9432C183.234 53.7456 183.533 50.9512 184.93 45.8613C185.13 45.2625 185.329 44.6637 185.529 44.0649L185.729 43.5659L185.828 44.0649C187.525 49.8534 187.924 53.546 186.826 54.9432ZM187.425 39.8733L187.325 39.5739V39.4741C189.222 35.4821 191.517 33.1867 193.413 33.1867C195.609 33.1867 197.106 35.1827 197.106 37.9771C197.106 39.8733 196.307 40.8713 195.609 41.4701C194.81 42.1687 193.812 42.4681 192.715 42.4681C190.12 42.5679 188.423 41.1707 187.425 39.8733ZM64.2715 44.3643C67.2655 44.1647 69.6607 40.0729 70.4591 38.3763L70.6587 37.8773L70.7585 38.3763C71.1577 40.7715 72.5549 44.8633 76.6467 44.9631C78.4431 44.9631 80.4391 43.8653 82.5349 41.7695L82.7345 41.5699L82.8343 41.7695C84.2315 44.0649 86.0279 45.3623 88.0239 45.1627C90.9182 44.9631 92.7146 42.9671 92.8144 41.5699C92.8144 41.1707 92.7146 40.8713 92.515 40.6717C92.2156 40.3723 91.9162 40.3723 91.6168 40.5719L91.517 40.6717C90.8184 41.3703 89.6208 42.5679 88.2236 42.5679C86.5269 42.6677 85.3293 41.6697 84.5309 39.5739V39.4741L84.6307 39.3743C89.2216 33.2865 92.515 24.1049 92.2156 17.9172C92.1158 15.023 91.2176 11.6298 88.1238 11.6298H87.8244C86.6267 11.7296 85.5289 12.2286 84.6307 13.3264C81.7365 16.6198 80.2395 24.6039 80.7385 33.6857C80.8383 35.5819 81.1377 37.3783 81.7365 38.9751V39.0749L81.6367 39.1747C79.9401 41.1707 78.2435 42.2685 76.8463 42.2685C73.5529 42.2685 73.6527 36.7795 73.9521 32.1887C74.0519 31.1907 74.0519 30.5919 73.7525 30.1927C73.5529 29.8933 73.1537 29.7935 72.6547 29.7935H72.5549C71.3573 29.7935 71.1577 29.9931 70.5589 31.7895C69.3613 35.3823 66.8663 41.3703 64.3713 41.3703C63.6727 41.3703 63.1737 41.1707 62.7745 40.6717C61.5769 39.1747 62.4751 35.3823 63.1737 32.2885C63.2735 31.7895 63.4731 31.1907 63.5729 30.6917C63.7725 29.9931 63.6727 29.3943 63.4731 29.0949C63.1737 28.7955 62.6747 28.5959 62.0759 28.6957C60.978 28.7955 60.3792 29.1947 59.98 31.1907L59.8802 31.5899V31.6897C59.3812 30.9911 58.483 30.1927 56.8862 30.1927C56.7864 30.1927 56.5868 30.1927 56.3872 30.1927C54.5908 30.2925 52.5948 31.5899 51.0978 33.3863C49.4012 35.5819 48.503 38.2765 48.8024 41.0709C48.8024 41.1707 48.8024 41.3703 48.9022 41.4701V41.5699L48.8024 41.6697C47.8044 42.7675 46.7066 43.3663 45.7086 43.3663C44.1118 43.3663 43.2136 42.1687 43.2136 40.1727C43.2136 36.7795 45.509 26.6997 45.509 23.0071C45.509 19.1148 43.8124 17.019 40.7186 16.9192C36.3273 16.9192 32.8343 21.9092 29.5409 32.1887C29.2415 33.1867 28.9421 34.1847 28.6427 35.1827L28.1437 36.7795L28.2435 35.1827C28.5429 31.6897 28.7425 28.2965 28.8423 24.8035C29.0419 19.8134 28.3433 16.6198 26.7465 15.023C25.9481 14.1248 24.8503 13.7256 23.3533 13.7256C17.9641 13.7256 15.3693 22.8075 13.4731 29.2945C12.8743 31.1907 11.7764 35.5819 11.0778 38.5759L11.477 37.8773C11.7764 34.0849 12.7745 24.7037 12.6747 19.6138C12.5749 14.1248 10.7784 11.6298 6.78643 11.6298C4.59082 11.6298 3.19361 12.7276 2.29541 13.6258C0.798403 14.9232 0 17.019 0 18.8154C0 19.9132 0.698603 20.9112 1.1976 20.9112C1.49701 20.9112 1.69661 20.4122 1.79641 20.2126C3.09381 16.1208 4.69062 14.1248 6.68663 14.1248C7.58483 14.1248 8.18363 14.4242 8.68263 14.9232C10.2794 16.6198 9.98004 21.3104 9.48104 29.8933C9.38124 32.4881 9.18164 35.6817 8.98204 39.1747C8.98204 39.7735 8.88224 40.3723 8.88224 40.9711C8.68263 43.4661 8.58283 45.3623 9.48104 45.4621C10.6786 45.6617 11.477 45.1627 11.8762 43.9651C12.475 42.1687 13.7725 37.2785 16.3673 28.3963C18.8623 19.9132 20.7585 16.7196 23.1537 16.7196C25.9481 16.7196 26.1477 21.51 25.6487 31.5899C25.5489 33.6857 25.3493 36.1807 25.2495 38.7755C25.2495 39.1747 25.2495 39.4741 25.2495 39.8733C25.1497 42.0689 25.0499 43.7655 25.6487 44.4641C25.8483 44.6637 26.1477 44.7635 26.4471 44.7635C27.6447 44.7635 28.0439 43.6657 28.6427 41.9691C28.7425 41.6697 28.8423 41.3703 28.9421 40.9711C33.0339 29.5939 36.1277 19.7136 40.2196 19.7136C41.4172 19.7136 42.4152 20.7116 42.4152 22.7077C42.4152 27.1987 40.2196 35.8813 40.2196 40.2725C40.2196 41.8693 40.7186 43.2665 41.517 44.2645C42.4152 45.2625 43.6128 45.8613 45.1098 45.8613C46.507 45.8613 47.9042 45.1627 49.4012 43.8653L49.501 43.7655L49.6008 43.8653C50.5988 45.1627 52.0958 45.8613 53.7924 45.6617C56.3872 45.4621 58.483 43.1667 59.2814 41.0709L59.481 40.6717L59.6806 41.0709C60.2794 42.6677 61.5769 44.6637 64.2715 44.3643ZM87.7246 14.6238C88.024 14.6238 88.3233 14.7236 88.523 15.023C89.521 16.4202 89.521 21.4102 87.8244 27.0989C86.8263 30.3923 85.5289 33.3863 83.9321 35.9811L83.6327 36.3803L83.5329 35.8813C83.3333 34.4841 83.2335 33.0869 83.2335 31.8893C82.9341 23.3065 85.5289 14.7236 87.7246 14.6238ZM59.481 34.6837C58.5828 38.2765 56.8862 42.5679 53.7924 42.8673H53.493C52.1956 42.8673 51.497 42.0689 51.3972 40.3723C51.1976 38.2765 52.0958 35.8813 53.6926 34.1847C54.6906 33.0869 55.7884 32.4881 56.7864 32.4881C58.1836 32.5879 59.0818 33.5859 59.481 34.6837ZM73.7525 21.51C72.6547 21.51 71.6567 22.4082 71.6567 23.5061C71.6567 24.6039 72.5549 25.5021 73.6527 25.5021V25.7017V25.5021C74.7505 25.5021 75.6487 24.6039 75.7485 23.5061C75.8483 22.4082 74.9501 21.51 73.7525 21.51ZM145.309 21.51C144.212 21.51 143.214 22.4082 143.214 23.5061C143.214 24.6039 144.112 25.5021 145.21 25.5021V25.7017V25.5021C146.307 25.5021 147.305 24.6039 147.305 23.5061C147.405 22.4082 146.507 21.51 145.309 21.51Z" fill="currentColor"></path>
        </svg> */}

              <p className="mt-3 sm:mt-6 text-base text-gray-800 md:text-xl ">
                <em>
                  " The multi-language support has been a game-changer for our clinic, allowing us
                  to better serve our diverse client base. "
                </em>
              </p>
            </div>

            <div className="p-4 rounded-b-xl md:px-6">
              <h3 className="text-sm font-semibold text-gray-800 sm:text-base ">Mark T.</h3>
              <p className="text-sm text-gray-500 ">Clinic Supervisor | Healthy Kids Clinic</p>
            </div>
          </div>
          {/* End Card */}
        </div>
        {/* End Grid */}
      </div>
      {/* End Testimonials */}
    </>
  );
};

const UniqueCapabilitiesSection = () => {
  return (
    <>
      {/* Features */}
      <div className="max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
        {/* Grid */}
        <div className="md:grid md:grid-cols-2 md:items-center md:gap-12 xl:gap-32">
          <div>
            <img
              className="rounded-xl"
              src="https://cdn.app.evalubox.com/marketing-site/narrative-assessment/summary_analysis.png"
              alt="Evalubox narrative assessment analysis summary and language sample transcript"
            />
          </div>
          {/* End Col */}

          <div className="mt-5 sm:mt-10 lg:mt-0">
            <div className="space-y-6 sm:space-y-8">
              {/* Title */}
              <div className="space-y-2 md:space-y-4">
                <h2 className="font-bold text-3xl lg:text-4xl text-gray-800 ">
                  Why Evalubox's Language Sample Transcription Tool?
                </h2>
              </div>
              {/* End Title */}

              {/* List */}
              <ul className="space-y-2 sm:space-y-4">
                <li className="flex space-x-3">
                  <span className="mt-0.5 size-5 flex justify-center items-center p-2 rounded-full bg-blue-50 text-blue-600 ">
                    <svg
                      className="flex-shrink-0 size-3.5"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </span>

                  <span className="text-xl sm:text-2xl text-gray-600 ">
                    <span className="font-bold">Specialized for SLPs:</span> Designed with the
                    unique needs of speech language pathologists in mind.
                  </span>
                </li>

                <li className="flex space-x-3">
                  <span className="mt-0.5 size-5 flex justify-center items-center rounded-full p-2 bg-blue-50 text-blue-600 ">
                    <svg
                      className="flex-shrink-0 size-3.5"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </span>

                  <span className="text-xl sm:text-2xl text-gray-600  ">
                    <span className="font-bold">Comprehensive Solution:</span> From intake to
                    assessment planning, we've got it all covered.
                  </span>
                </li>

                <li className="flex space-x-3">
                  <span className="mt-0.5 size-5 flex justify-center items-center p-2 rounded-full bg-blue-50 text-blue-600 ">
                    <svg
                      className="flex-shrink-0 size-3.5"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </span>

                  <span className="text-xl sm:text-2xl text-gray-600  ">
                    <span className="font-bold">Expertise:</span> Created by professionals who
                    understand the intricacies of speech-language evaluations.
                  </span>
                </li>
              </ul>
              {/* End List */}
            </div>
          </div>
          {/* End Col */}
        </div>
        {/* End Grid */}
      </div>
      {/* End Features */}
    </>
  );
};
const ComparisonSection = () => {
  return (
    <section className="bg-blue-50">
      <div className="mx-auto max-w-screen-xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <h2 className="text-center text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
          Traditional Way vs. Evalubox
        </h2>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-8">
          <blockquote className="rounded-lg bg-white p-6 shadow-sm sm:p-8">
            <h2 className="text-center text-xl font-bold tracking-tight text-gray-900 sm:text-2xl">
              Traditional Way
            </h2>
            {/* <p className="mt-4 text-gray-700 text-xl">
            Paper forms, manual follow-ups, and inconsistent processes.
            </p> */}
            <ul className="list-disc pt-4">
              <li className="flex items-center space-x-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={4.5}
                  stroke="currentColor"
                  className="flex-shrink-0 w-3.5 h-3.5 text-red-500 dark:text-red-400"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                </svg>

                <p className="text-lg md:text-xl text-gray-700">Manual transcription takes hours</p>
              </li>
              <li className="flex items-center space-x-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={4.5}
                  stroke="currentColor"
                  className="flex-shrink-0 w-3.5 h-3.5 text-red-500 dark:text-red-400"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                </svg>
                <p className="text-lg md:text-xl text-gray-700">
                  Analysis is subjective and time-consuming
                </p>
              </li>
              <li className="flex items-center space-x-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={4.5}
                  stroke="currentColor"
                  className="flex-shrink-0 w-3.5 h-3.5 text-red-500 dark:text-red-400"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                </svg>
                <p className="text-lg md:text-xl text-gray-700">
                  Difficult to manage alongside other responsibilities
                </p>
              </li>
            </ul>
          </blockquote>

          <blockquote className="rounded-lg bg-white p-6 shadow-sm sm:p-8">
            <h2 className="text-center text-xl font-bold tracking-tight text-gray-900 sm:text-2xl">
              Evalubox
            </h2>
            <p className="mt-4 text-gray-700 text-xl">
              {/* You're ready to analyze your results and make a diagnostic decision but you end up shuffling through multiple files/docs/papers to find the information you need can be frustrating. */}
              {/* When you sit down to analyze your results to make a diagnostic decision, you end up shuffling through multiple files/docs/papers to find the information you need, which can be time consuming and frustrating. */}
              {/* Electronic forms, automated tracking, and consistent workflows. */}
            </p>
            <ul className="list-disc pt-4">
              <li className="flex items-center space-x-3">
                <svg
                  className="flex-shrink-0 w-3.5 h-3.5 text-green-500 dark:text-green-400"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 16 12"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="4.5"
                    d="M1 5.917 5.724 10.5 15 1.5"
                  />
                </svg>
                <p className="text-lg md:text-xl text-gray-900">
                  Automatic transcription in minutes
                </p>
              </li>
              <li className="flex items-center space-x-3">
                <svg
                  className="flex-shrink-0 w-3.5 h-3.5 text-green-500 dark:text-green-400"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 16 12"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="4.5"
                    d="M1 5.917 5.724 10.5 15 1.5"
                  />
                </svg>
                <p className="text-lg md:text-xl text-gray-900">Objective, detailed analysis</p>
              </li>
              <li className="flex items-center space-x-3">
                <svg
                  className="flex-shrink-0 w-3.5 h-3.5 text-green-500 dark:text-green-400"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 16 12"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="4.5"
                    d="M1 5.917 5.724 10.5 15 1.5"
                  />
                </svg>
                <p className="text-lg md:text-xl text-gray-900">
                  Saves time, enabling better focus on client care
                </p>
              </li>
            </ul>
          </blockquote>
        </div>
      </div>

      <QuestionsToAsk />
    </section>
  );
};

const QuestionsToAsk = () => {
  return (
    <>
      <div className="mx-auto max-w-screen-xl px-4 py-4 sm:px-6 lg:px-8 lg:py-4">
        <h2 className="text-left text-3xl mb-4 font-bold tracking-tight text-gray-900 sm:text-3xl">
          Questions to Consider
        </h2>
        <ul className="list-disc list-inside mb-4 pl-2 text-base space-y-2">
          <li className="flex items-center space-x-3">
            {/* <svg
              className="flex-shrink-0 w-3.5 h-3.5 text-green-500 dark:text-green-400"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 16 12"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="4.5"
                d="M1 5.917 5.724 10.5 15 1.5"
              />
            </svg> */}
            <svg
              className="flex-shrink-0 w-6 h-6 text-primary"
              data-slot="icon"
              aria-hidden="true"
              fill="none"
              stroke-width="2.5"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </svg>
            <p className="text-lg md:text-xl text-gray-900">
              How much time are you spending on manually transcribing language samples?
            </p>
          </li>
          <li className="flex items-center space-x-3">
            <svg
              className="flex-shrink-0 w-6 h-6 text-primary"
              data-slot="icon"
              aria-hidden="true"
              fill="none"
              stroke-width="2.5"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </svg>
            <p className="text-lg md:text-xl text-gray-900">
              Are you confident in your current analysis process?
            </p>
          </li>
          <li className="flex items-center space-x-3">
            <svg
              className="flex-shrink-0 w-6 h-6 text-primary"
              data-slot="icon"
              aria-hidden="true"
              fill="none"
              stroke-width="2.5"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </svg>
            <p className="text-lg md:text-xl text-gray-900">
              Would you benefit from a more efficient, accurate, and reliable system?
            </p>
          </li>
        </ul>
      </div>
    </>
  );
};

const UseCasesSection = () => {
  return (
    <section className="bg-white">
      <div className="mx-auto max-w-screen-xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <h2 className="text-center text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
          Relevant for
        </h2>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-1 md:gap-8">
          <blockquote className="rounded-lg bg-gray-50 p-6 shadow-sm sm:p-8">
            <h2 className="text-center text-xl font-bold tracking-tight text-gray-900 sm:text-2xl">
              School, Clinic, and Medical SLPs:
            </h2>
            <p className="mt-4 text-gray-700 text-xl">
              Whether you work in a school, clinic, or hospital setting, Evalubox streamlines your
              language sampling process, allowing you to deliver faster, more accurate results to
              clients and their families.
            </p>
          </blockquote>
        </div>
      </div>
    </section>
  );
};

const ProblemSection = () => {
  return (
    <section className="bg-white">
      <div className="mx-auto max-w-screen-xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <h2 className="text-center text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
          Why Does the Language Sampling Process Take So Long for Most People?
        </h2>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-8">
          <blockquote className="rounded-lg bg-gray-50 p-6 shadow-sm sm:p-8">
            <h2 className="text-center text-xl font-bold tracking-tight text-gray-900 sm:text-2xl">
              Manual Transcription:
            </h2>
            <p className="mt-4 text-gray-700 text-xl">
              Transcribing a language sample manually or paying to have it transcribed and waiting
              for it to be returned can add hours to the report-writing process.
            </p>
            <p className="mt-8 text-gray-700 text-xl">
              Wouldn’t you rather upload or record a sample from any device and have it available
              immediately?
            </p>
          </blockquote>

          <blockquote className="rounded-lg bg-gray-50 p-6 shadow-sm sm:p-8">
            <h2 className="text-center text-xl font-bold tracking-tight text-gray-900 sm:text-2xl">
              Complex Analysis:
            </h2>
            <p className="mt-4 text-gray-700 text-xl">
              {/* You're ready to analyze your results and make a diagnostic decision but you end up shuffling through multiple files/docs/papers to find the information you need can be frustrating. */}
              {/* When you sit down to analyze your results to make a diagnostic decision, you end up shuffling through multiple files/docs/papers to find the information you need, which can be time consuming and frustrating. */}
              Analyzing samples for linguistic differences and comparing samples requires deep
              concentration and knowledge about what should or should not be expected.
            </p>
            <p className="mt-8 text-gray-700 text-xl">
              Wouldn’t you rather be guided through the process using narrative and grammatical
              checklists?
            </p>
          </blockquote>

          <blockquote className="rounded-lg bg-gray-50 p-6 shadow-sm sm:p-8">
            <h2 className="text-center text-xl font-bold tracking-tight text-gray-900 sm:text-2xl">
              Subjective Judgement:
            </h2>
            <p className="mt-4 text-gray-700 text-xl">
              Making informed decisions about whether a client has a language disorder can feel
              overwhelming and subjective, especially with students from diverse backgrounds.
            </p>
            <p className="mt-8 text-gray-700 text-xl">
              Wouldn’t you rather have a second sample demonstrating how a child performs after
              being shown how to tell a story?
            </p>
          </blockquote>
        </div>
      </div>
    </section>
  );
};

const SolutionIntroSection = () => {
  return (
    <section className="bg-blue-50 mt-10">
      <div className="mx-auto max-w-screen-xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <h2 className="text-center text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
          {/* Evalubox helps you assemble a comprehensive evaluation report you're proud of  */}
          Evalubox Helps You Effortlessly Record, Transcribe <br />
          and Analyze Language Samples
          {/* Evalubox helps you gather information faster in three steps: */}
          <strong className="font-extrabold text-orange-600 sm:block p-2 block">
            In Three Steps
          </strong>
        </h2>
      </div>
    </section>
  );
};
